import type { Building } from "building-types/building/buildingTypes";
import { FloorAreaTakeoffType } from "building-types/rooms/takeoffTypes";

export function getBuildingFloorAreaTakeoffAreas({ floorAreaTakeoffs }: Pick<Building, "floorAreaTakeoffs">) {
  const garageArea = floorAreaTakeoffs[FloorAreaTakeoffType.TOTAL_GARAGE_AREA]?.totalFloorArea ?? 0;
  const unconditionedArea = floorAreaTakeoffs[FloorAreaTakeoffType.UNCONDITIONED_FLOOR_AREA]?.totalFloorArea ?? 0;

  return {
    unconditionedArea: unconditionedArea - garageArea,
    garageArea,
    frontPorchArea: floorAreaTakeoffs[FloorAreaTakeoffType.FRONT_PORCH_AREA]?.totalFloorArea ?? 0,
    rearPorchArea: floorAreaTakeoffs[FloorAreaTakeoffType.REAR_PORCH_AREA]?.totalFloorArea ?? 0,
    coveredPatioArea: floorAreaTakeoffs[FloorAreaTakeoffType.COVERED_PATIO_AREA]?.totalFloorArea ?? 0,
    uncoveredPatioArea: floorAreaTakeoffs[FloorAreaTakeoffType.UNCOVERED_PATIO_AREA]?.totalFloorArea ?? 0,
  };
}
